import React, { useState } from 'react';
import { Filter, Search, FileText, AlertCircle, ShoppingCart, X, Plus, Minus, Star, Info } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
interface CatalogProps {
  onNavigate: (page: string) => void;
}
interface CartItem {
  id: string;
  name: string;
  sku: string;
  price: number;
  quantity: number;
  unit: string;
  moq: number;
}
export function Catalog({
  onNavigate
}: CatalogProps) {
  const [activeCategory, setActiveCategory] = useState('all');
  const [cart, setCart] = useState<CartItem[]>([{
    id: '1',
    name: 'Minyak Goreng Sania 2L',
    sku: 'SKU-MG-001',
    price: 35000,
    quantity: 12,
    unit: 'Pouch',
    moq: 12
  }, {
    id: '2',
    name: 'Gula Pasir Gulaku 1kg',
    sku: 'SKU-GL-002',
    price: 14500,
    quantity: 24,
    unit: 'Pack',
    moq: 24
  }, {
    id: '3',
    name: 'Indomie Goreng Special',
    sku: 'SKU-IM-003',
    price: 3100,
    quantity: 40,
    unit: 'Pcs',
    moq: 40
  }]);
  const [showCart, setShowCart] = useState(false);
  const categories = [{
    id: 'all',
    label: 'Semua Produk'
  }, {
    id: 'food',
    label: 'Makanan & Minuman'
  }, {
    id: 'household',
    label: 'Rumah Tangga'
  }, {
    id: 'personal',
    label: 'Perawatan Pribadi'
  }];
  const products = [{
    id: '1',
    sku: 'SKU-MG-001',
    name: 'Minyak Goreng Sania 2L',
    price: 35000,
    unit: 'Pouch',
    moq: 12,
    stock: 'In Stock',
    leadTime: '2-3 hari',
    category: 'Food'
  }, {
    id: '2',
    sku: 'SKU-GL-002',
    name: 'Gula Pasir Gulaku 1kg',
    price: 14500,
    unit: 'Pack',
    moq: 24,
    stock: 'In Stock',
    leadTime: '1-2 hari',
    category: 'Food'
  }, {
    id: '3',
    sku: 'SKU-IM-003',
    name: 'Indomie Goreng Special',
    price: 3100,
    unit: 'Pcs',
    moq: 40,
    stock: 'Stok Terbatas',
    leadTime: '3-5 hari',
    category: 'Food'
  }, {
    id: '4',
    sku: 'SKU-KP-004',
    name: 'Kopi Kapal Api Special',
    price: 12000,
    unit: 'Pack',
    moq: 10,
    stock: 'In Stock',
    leadTime: '2-3 hari',
    category: 'Beverage'
  }];
  const addToCart = (product: (typeof products)[0], quantity: number) => {
    const existingItem = cart.find(item => item.id === product.id);
    if (existingItem) {
      setCart(cart.map(item => item.id === product.id ? {
        ...item,
        quantity: item.quantity + quantity
      } : item));
    } else {
      setCart([...cart, {
        id: product.id,
        name: product.name,
        sku: product.sku,
        price: product.price,
        quantity: quantity,
        unit: product.unit,
        moq: product.moq
      }]);
    }
  };
  const updateQuantity = (id: string, newQuantity: number) => {
    const item = cart.find(i => i.id === id);
    if (item && newQuantity >= item.moq) {
      setCart(cart.map(i => i.id === id ? {
        ...i,
        quantity: newQuantity
      } : i));
    }
  };
  const removeFromCart = (id: string) => {
    setCart(cart.filter(item => item.id !== id));
  };
  const cartTotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const cartItemCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  return <div className="space-y-4 pb-6" data-id="element-1346">
      {/* Search & Filter */}
      <div className="flex gap-2" data-id="element-1347">
        <div className="relative flex-1" data-id="element-1348">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-1349" />
          <input type="text" placeholder="Cari berdasarkan SKU atau nama produk..." className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-1350" />
        </div>
        <button className="p-3 bg-white rounded-xl border border-slate-200 hover:bg-slate-50 transition-colors" data-id="element-1351">
          <Filter className="w-5 h-5 text-slate-600" data-id="element-1352" />
        </button>
        <button className="p-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors relative" onClick={() => setShowCart(!showCart)} data-id="element-1353">
          <ShoppingCart className="w-5 h-5" data-id="element-1354" />
          {cart.length > 0 && <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center" data-id="element-1355">
              {cart.length}
            </span>}
        </button>
      </div>

      {/* Category Tabs */}
      <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-1356">
        {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`
              px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors
              ${activeCategory === cat.id ? 'bg-blue-600 text-white shadow-md' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'}
            `} data-id="element-1357">
            {cat.label}
          </button>)}
      </div>

      {/* Cart Sidebar */}
      {showCart && <Card className="p-4 border-blue-200 bg-blue-50" data-id="element-1358">
          <div className="flex items-center justify-between mb-4" data-id="element-1359">
            <h3 className="font-bold text-slate-900" data-id="element-1360">Keranjang Requisition</h3>
            <button onClick={() => setShowCart(false)} data-id="element-1361">
              <X className="w-5 h-5 text-slate-400" data-id="element-1362" />
            </button>
          </div>

          <div className="space-y-3 mb-4 max-h-64 overflow-y-auto" data-id="element-1363">
            {cart.map(item => <div key={item.id} className="bg-white rounded-lg p-3" data-id="element-1364">
                <div className="flex items-start justify-between mb-2" data-id="element-1365">
                  <div className="flex-1" data-id="element-1366">
                    <h4 className="font-bold text-sm text-slate-900" data-id="element-1367">
                      {item.name}
                    </h4>
                    <p className="text-xs text-slate-500 font-mono" data-id="element-1368">
                      {item.sku}
                    </p>
                  </div>
                  <button onClick={() => removeFromCart(item.id)} className="text-red-500 hover:text-red-700" data-id="element-1369">
                    <X className="w-4 h-4" data-id="element-1370" />
                  </button>
                </div>

                <div className="flex items-center justify-between" data-id="element-1371">
                  <div className="flex items-center gap-2" data-id="element-1372">
                    <button onClick={() => updateQuantity(item.id, item.quantity - item.moq)} className="w-6 h-6 bg-slate-100 rounded flex items-center justify-center hover:bg-slate-200" disabled={item.quantity <= item.moq} data-id="element-1373">
                      <Minus className="w-3 h-3" data-id="element-1374" />
                    </button>
                    <span className="text-sm font-bold w-12 text-center" data-id="element-1375">
                      {item.quantity}
                    </span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + item.moq)} className="w-6 h-6 bg-slate-100 rounded flex items-center justify-center hover:bg-slate-200" data-id="element-1376">
                      <Plus className="w-3 h-3" data-id="element-1377" />
                    </button>
                  </div>
                  <span className="font-bold text-blue-600" data-id="element-1378">
                    Rp {(item.price * item.quantity).toLocaleString('id-ID')}
                  </span>
                </div>
              </div>)}
          </div>

          <div className="border-t border-blue-200 pt-3 mb-3" data-id="element-1379">
            <div className="flex justify-between items-center mb-1" data-id="element-1380">
              <span className="text-sm text-slate-600" data-id="element-1381">Total Item:</span>
              <span className="font-bold" data-id="element-1382">{cartItemCount} unit</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-1383">
              <span className="font-bold text-slate-900" data-id="element-1384">Total:</span>
              <span className="font-extrabold text-xl text-blue-600" data-id="element-1385">
                Rp {cartTotal.toLocaleString('id-ID')}
              </span>
            </div>
          </div>

          <Button variant="primary" fullWidth size="lg" onClick={() => onNavigate('checkout')} icon={<FileText className="w-5 h-5" data-id="element-1387" />} data-id="element-1386">
            Review Requisition
          </Button>
        </Card>}

      {/* Product List */}
      <div className="space-y-3" data-id="element-1388">
        {products.map(product => {
        const [quantity, setQuantity] = useState(product.moq);
        const inCart = cart.find(item => item.id === product.id);
        return <Card key={product.id} className="p-4 hover:shadow-md transition-shadow" data-id="element-1389">
              <div className="flex items-start gap-3 mb-3" data-id="element-1390">
                <div className="w-20 h-20 bg-slate-100 rounded-lg flex-shrink-0 relative" data-id="element-1391">
                  <img src={`https://images.unsplash.com/photo-1620706857370-e1b9770e8bb1?auto=format&fit=crop&q=80&w=100`} className="w-full h-full object-cover rounded-lg" alt="" data-id="element-1392" />
                  <button className="absolute top-1 right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-yellow-50 transition-colors" data-id="element-1393">
                    <Star className="w-4 h-4 text-slate-400" data-id="element-1394" />
                  </button>
                </div>
                <div className="flex-1 min-w-0" data-id="element-1395">
                  <div className="flex items-start justify-between gap-2 mb-1" data-id="element-1396">
                    <div data-id="element-1397">
                      <p className="text-xs text-slate-500 font-mono mb-1" data-id="element-1398">
                        {product.sku}
                      </p>
                      <h3 className="font-bold text-slate-900 leading-tight" data-id="element-1399">
                        {product.name}
                      </h3>
                    </div>
                    <Badge variant={product.stock === 'In Stock' ? 'success' : 'warning'} data-id="element-1400">
                      {product.stock}
                    </Badge>
                  </div>

                  <div className="flex items-center gap-3 text-xs text-slate-500 mt-2" data-id="element-1401">
                    <span data-id="element-1402">
                      MOQ:{' '}
                      <span className="font-bold text-slate-700" data-id="element-1403">
                        {product.moq} {product.unit}
                      </span>
                    </span>
                    <span className="text-slate-300" data-id="element-1404">•</span>
                    <span data-id="element-1405">Lead Time: {product.leadTime}</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between pt-3 border-t border-slate-100" data-id="element-1406">
                <div data-id="element-1407">
                  <p className="text-xs text-slate-500 mb-1" data-id="element-1408">Harga Satuan</p>
                  <p className="text-lg font-bold text-blue-600" data-id="element-1409">
                    Rp {product.price.toLocaleString('id-ID')}
                    <span className="text-xs text-slate-400 font-normal ml-1" data-id="element-1410">
                      /{product.unit}
                    </span>
                  </p>
                </div>

                <div className="flex items-center gap-2" data-id="element-1411">
                  {inCart ? <div className="flex items-center gap-2 bg-green-50 px-3 py-2 rounded-lg border border-green-200" data-id="element-1412">
                      <span className="text-xs font-bold text-green-700" data-id="element-1413">
                        {inCart.quantity} di keranjang
                      </span>
                      <button onClick={() => setShowCart(true)} className="text-green-600 hover:text-green-700" data-id="element-1414">
                        <Info className="w-4 h-4" data-id="element-1415" />
                      </button>
                    </div> : <>
                      <input type="number" value={quantity} onChange={e => setQuantity(Math.max(product.moq, parseInt(e.target.value) || product.moq))} min={product.moq} step={product.moq} className="w-20 px-3 py-2 border border-slate-200 rounded-lg text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1416" />
                      <Button size="sm" variant="primary" onClick={() => {
                  addToCart(product, quantity);
                  setQuantity(product.moq);
                }} data-id="element-1417">
                        Tambah ke PO
                      </Button>
                    </>}
                </div>
              </div>

              {product.stock === 'Stok Terbatas' && <div className="mt-3 flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg p-2" data-id="element-1418">
                  <AlertCircle className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-1419" />
                  <p className="text-xs text-amber-700" data-id="element-1420">
                    Ketersediaan terbatas. Pesan segera untuk mengamankan stok.
                  </p>
                </div>}
            </Card>;
      })}
      </div>
    </div>;
}